/** An enum indicating in what mode the validation flow is running */
enum FlowMode {
  /** The user can select between the full or partial flow */
  userSelect = 'userSelect',
  /** Perform all steps in on one browser */
  full = 'full',
  /** Perform partial steps by exchanging a token */
  partial = 'partial',
  /** Generate an exchange token and wait for steps to be completed */
  handover = 'handover',
}

export default FlowMode;
